export const SET_AREAS_OF_STORE = 'SET_AREAS_OF_STORE'
export const SET_SELECTED_AREA = 'SET_SELECTED_AREA'
